exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HR__HR__3BOJY {\n    width: 100%;\n    height: 2px;\n    background-color: #a6abbd;\n    padding: 0 1rem;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    background-clip: content-box;\n    margin-bottom: 0;\n}", ""]);

// exports
exports.locals = {
	"HR": "HR__HR__3BOJY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/UI/HR/HR.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/UI/HR/HR.css
// module chunks = 0